import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, Dimmer, Grid, Loader } from 'semantic-ui-react';
import { productsModulesActions } from '../../actions/products-modules.actions';

class ProductsModulesShowScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      submitted: false,
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(productsModulesActions.getById(match.params.id));
  }

  handleCancel = () => this.setState({ open: false });

  deleteShow = () => this.setState({ open: true });

  deleteById() {
    const { match, dispatch } = this.props;

    dispatch(productsModulesActions.deleteById(match.params.id)).then(() =>
      this.props.history.push('/product/modules'),
    );
  }

  editById() {
    const { match } = this.props;

    this.props.history.push(`/product/modules/${match.params.id}/edit`);
  }

  render() {
    const { productsModules, loading } = this.props;
    const { open } = this.state;

    if (!productsModules)
      return (
        <Dimmer active>
          <Loader />
        </Dimmer>
      );

    return (
      <Fragment>
        <Confirm
          content="Deseja remover esse item?"
          open={open}
          onCancel={this.handleCancel}
          onConfirm={() => this.deleteById()}
        />
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <h1>{productsModules.name}</h1>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={6} computer={6} textAlign="right">
            <Button icon="edit outline" onClick={() => this.editById()} />
            <Button icon="trash alternate outline" onClick={this.deleteShow} />
          </Grid.Column>
        </Grid>
        <Loader active={loading} />
        <div className="container-inner">
          <h4>Produto: </h4>
          {productsModules.product ? productsModules.product.name : ''}
          <h4>Nome: </h4>
          {productsModules.name}
          <h4>Descrição: </h4>
          <div dangerouslySetInnerHTML={{ __html: productsModules.description }}></div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { productsModules } = state;
  return {
    productsModules: productsModules.item,
    loading: productsModules.loading || false,
  };
}

const connectedProductsModulesShowScreen = connect(mapStateToProps)(ProductsModulesShowScreen);
export { connectedProductsModulesShowScreen as ProductsModulesShowScreen };
